import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import styles from './chatbot-feedback.module.css';

export interface LegendItemProps {
    color: string;
    label: string;
}

export function LegendItem(props: LegendItemProps) {
    return (
        <Stack isHorizontal={true} spacing={4} alignItems='center'>
            <span className={styles['square']} style={{backgroundColor: props.color}} />
            <Body size='small'>{props.label}</Body>
        </Stack>
    );
}
